import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isTenantUser } from '../../lib/authRoles';
import { RouteAuthSpinner } from './RouteAuthSpinner';

export function AppHomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return <RouteAuthSpinner />;
  }
  if (isTenantUser(user)) {
    return <Navigate to="/app/tenant" replace />;
  }
  return <Navigate to="/app/dashboard" replace />;
}
